import { useState } from "react";
import "./toggle.css";

/**
 * Toggle Switch Component
 *
 * @param {Object} props
 * @param {boolean} [props.checked] — When provided, the toggle is controlled (visual state follows this value).
 * @param {Function} props.onChange - Callback function when toggle state changes
 * @param {string} props.className - Additional CSS classes on the layout wrapper
 * @param {boolean} props.disabled - Whether the toggle is disabled
 */
export default function Toggle({
    checked: checkedProp,
    onChange,
    className = "",
    disabled = false,
    ...props
}) {
    const [internalChecked, setInternalChecked] = useState(false);

    const isControlled = checkedProp !== undefined;
    const isChecked = isControlled ? Boolean(checkedProp) : internalChecked;

    const handleToggle = () => {
        if (disabled) return;
        const newValue = !isChecked;
        if (!isControlled) {
            setInternalChecked(newValue);
        }
        if (onChange) {
            onChange(newValue);
        }
    };

    return (
        <span className={`toggle-root ${className}`.trim()}>
            <button
                type="button"
                role="switch"
                aria-checked={isChecked}
                onClick={handleToggle}
                disabled={disabled}
                className={`toggle-switch ${isChecked ? "toggle-checked" : ""} ${disabled ? "toggle-disabled" : ""}`}
                {...props}
            >
                <span className="toggle-ball" aria-hidden="true" />
            </button>
        </span>
    );
}
